import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId, langSupport} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';
import FieldComponent from '../FieldComponent/FieldComponent';

export default class FieldSelect extends FieldComponent {

    constructor(props) {
        super(props);

        this.state.value = this.props.option.value || 0;
        this.state.preData = this.props.option.preData || [];

        this.getDataByValue = this.getDataByValue.bind(this);
    }

    getDataByValue(value) {
        return this.state.data.find(item => item.id === value);
    }

    setPreData(preData) {
        this.setState({preData});
    }

    render() {
        return (
            <div className={classNames("field-wrap", this.state.className)}>
                <div className="fb-row fb-sb-c">
                    {this.props.option.label &&
                    <label htmlFor={this.labelId} className="label">{i18n(this.props.option.label, this.props.setting.lang)}{this.getMark()}</label>
                    }
                    {this.props.option.labelFunc &&
                    <label htmlFor={this.labelId} className="label">{this.props.option.labelFunc(this.props.setting.lang)}{this.getMark()}</label>
                    }
                    {this.getSpinner()}
                </div>
                <div className="fb-col">
                    {this.state.enabledError &&
                    <div className={classNames(this.state.error.length === 0 && 'invisible', 'error')}>{i18n(this.state.error, this.props.setting.lang)}&nbsp;</div>
                    }
                    <select id={this.labelId} ref={this.ui} className={this.state.error.length > 0 ? 'error-border' : ''} disabled={!this.state.enabled} onChange={e => this.onChange(e.currentTarget.value)} value={this.state.value}>
                        {this.state.preData.map(function (item) {
                            return (
                                <option key={item.id} value={item.id} disabled={item.disabled === true}>{i18n(item.name, this.props.setting.lang)}</option>
                            );
                        }, this)}
                        {this.state.data.map(function (item) {
                            if (this.props.option.onDisplay) {
                                return this.props.option.onDisplay(item);
                            } else {
                                return <option key={item.id} value={item.id}>{item.name}</option>
                            }
                        }, this)}
                    </select>
                    <div className="help">{i18n(this.props.option.help, this.props.setting.lang)}</div>
                </div>
            </div>
        );
    }

}